import axios from "axios";
import { BASEURL } from "../config/index";
import { TokenService, CityService, PwaService } from "./tokenService";

const skipHeadersUrls = [
  "generic/site-data",
  "banners",
  "countries",
  "country-specific-data",
  "coming-soon",
  "movie-languages",
  "cities",
  "movie-genres",
  "promotions",
  "quick-book",
  "movies/experiences-filters",
  "movies/movie-details/",
  "movies/show-dates",
  "movies/show-times",
  "movies/now-playing",
  "booking/ticket-price",
  "booking/seat-layout-test",
  "fnb/fnb-items",
  "fnb/categories",
  "fnb/modifiers",
  "fnb/modifier-group",
  "fnb/modifiers"
]; // add URLs (or substrings) here

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: `${BASEURL}`,
  });

  instance.interceptors.request.use(function (config) {
    // check if current request URL matches any skip URL
    const shouldSkip = skipHeadersUrls.some((url) => config.url.includes(url));

    if (!shouldSkip) {
      const token = TokenService.getToken();
      const isPwa = PwaService.getIsPwa();
      const city_data = CityService.getCity();

      if (token) {
        config.headers.Authorization = token;
      }
      if (isPwa) {
        config.headers.ISPWA = isPwa;
      }
      if (city_data) {
        config.headers.CITY_ID = city_data.cityId;
      }
    }

    return config;
  });

  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && error.response.status === 401) {
        TokenService.removeToken();
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default createAxiosInstance;
